<div class="insights-container">
  <div *ngIf="compareToFleet; else elseBlock">

    <div class="row ms-2 me-2 mt-1 mb-1 ps-0 pe-0">
      <div class="col-md-6 ps-0 pe-0">
        <app-current-sohc-chart-ef [selectedVehicles]="selectedVehicles" *ngIf="fleetId.length > 0" [fleetId]="fleetId"></app-current-sohc-chart-ef>
      </div>
      <div class="col-md-6 ps-0 pe-0">
        <app-vehicle-mileage-chart-ef [selectedVehicles]="selectedVehicles" *ngIf="fleetId.length > 0" [fleetId]="fleetId" [companyData]="companyData" [isMetric]="isMetric"></app-vehicle-mileage-chart-ef>
      </div>
    </div>

    <hr class="ms-2 me-2 mt-1 mb-1 ps-0 pe-0">

    <div class="row ms-2 me-2 mt-1 mb-1 ps-0 pe-0">
      <div class="col-md-12 ps-0 pe-0">
        <app-avg-ev-efficiency-chart-ef [selectedVehicles]="selectedVehicles" *ngIf="fleetId.length > 0" [fleetId]="fleetId" [companyData]="companyData" [isMetric]="isMetric"></app-avg-ev-efficiency-chart-ef>
      </div>
      <!-- <div class="col-md-6 ps-0 pe-0">
        <app-stress-factor-ef-chart [selectedVehicles]="selectedVehicles" *ngIf="fleetId.length > 0"
          [fleetId]="fleetId"></app-stress-factor-ef-chart>
      </div> -->
    </div>

  </div>

  <ng-template #elseBlock>

    <rb-loading-spinner *ngIf="dataLoading" class="spinner"></rb-loading-spinner>
    <div class="row ms-2 me-2 mt-1 mb-1 ps-0 pe-0" *ngIf="errorMessage">
      <rb-callout type="warning">
        No Vehicle data.
      </rb-callout>
    </div>
    <div class="row ms-2 me-2 mt-1 mb-1 ps-0 pe-0" *ngIf="!dataLoading">
      <rb-tab-panel>
        <ng-container *ngFor="let tab of dynamicTabItems">
          <div *rbTabPanelItem="dynamicTab; details: tab; id: tab.name+tab.batteryIdentifier" class="row sub-tab-content">
            <h4 style="margin: 1rem 0">{{tab.name ? (tab.name) : 'N/A'}}</h4>
            <div class="col-md-6 ps-5 pe-5">
              <img src="{{ tab.urlImage ? (tab.urlImage) : '' }}" alt="{{ tab.name ? (tab.name) : 'N/A'}}">
              <div class="row">
                <div class="col-6">
                  <div class="button-container">
                    <span class="label">Brand</span>
                    <span>{{ tab.vehicleBrand ? (tab.vehicleBrand) : 'N/A' }}</span>
                  </div>
                </div>
                <div class="col-6">
                  <div class="button-container">
                    <span class="label">Model</span>
                    <span>{{ tab.vehicleModel ? (tab.vehicleModel) : 'N/A' }}</span>
                  </div>
                </div>
              </div>

              <div class="row mt-2">
                <div class="col-6">
                  <div class="button-container">
                    <span class="label">License Plate</span>
                    <span>{{ tab.currentVehicleInsights?.licensePlate === null || tab.currentVehicleInsights?.licensePlate === undefined || tab.currentVehicleInsights?.licensePlate === ""  ? 'N/A' : tab.currentVehicleInsights?.licensePlate }}</span>
                  </div>
                </div>
                <div class="col-6">
                  <div class="button-container">
                    <span class="label">Current Mileage</span>
                    <span>{{ getFormattedMileage(tab.currentVehicleInsights?.mileage) }}</span>
                  </div>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-6">
                  <div class="button-container">
                    <span class="label">Range from Efficiency</span>
                    <span>{{ getFormattedRange(tab.currentVehicleInsights?.currRange) }}
                      <span
                        class="rb-ic rb-ic-clock"
                        *ngIf="tab.currentVehicleInsights?.resultStatus === 'outdated'"
                        [rbTooltip]="'Last datapoint: ' + (tab.currentVehicleInsights?.timestamp ? (tab.currentVehicleInsights.timestamp | date:'dd MMM yyyy') : 'N/A')"
                      >
                      </span>
                      <!-- TODO: Enable result reasons tooltip -->
                      <!-- <ng-template let-close="close" let-fixed="fixed" #resultReasons>
                        <div class="p-1">
                          <button type="button" class="rb-btn rb-tiny" (click)="close()" *ngIf="fixed">
                            <span class="rb-ic rb-ic-close"></span>
                          </button>
                          <div *ngFor="let reason of tab.currentVehicleInsights?.resultReasons">
                            <span>
                              {{ reason }}
                            </span>
                            <br/>
                          </div>
                        </div>
                      </ng-template> -->
                    </span>
                  </div>
                </div>
                <div class="col-6">
                  <div class="button-container">
                    <span class="label">Avg. Efficiency</span>
                    <span>{{ getFormattedAvgEfficiency(tab.currentVehicleInsights?.avgEvEfficiency) }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 ps-5 pe-5">
              <div *ngIf="tab?.currentVehicleInsights && tab?.currentVehicleInsights?.resultStatus == 'outdated'" class="shaded-container p-0">
                <h4 class="mb-1 ms-3">
                  Result Status: Outdated
                  <span
                    class="rb-ic rb-ic-clock"
                    [rbTooltip]="'Last datapoint: ' + (tab.currentVehicleInsights?.timestamp ? (tab.currentVehicleInsights.timestamp | date:'dd MMM yyyy') : 'N/A')">
                  </span>
                </h4>
                <!-- TODO: Enable result reasons -->
                <!-- <div *ngFor="let reason of tab?.currentVehicleInsights?.resultReasons">
                  <span class="d-block ms-3">
                    {{ reason }}
                  </span>
                </div> -->
              </div>
              <div *ngIf="tab.currentVehicleInsights && tab.currentVehicleInsights.evStatusCode==2"
                style="background-color: var(--bosch-green-90);">
                <h4 class="mb-1 ms-3">{{ tab.currentVehicleInsights.rating }}</h4>
                <ng-container *ngIf="tab.stressFactorInfo && tab.stressFactorInfo.length">
                  <span class="d-block ms-3" *ngFor="let sf of tab.stressFactorInfo">
                    <ng-container *ngIf="(sf.level || 0) > 1">
                      <span
                        [ngStyle]="{'color': (sf.level || 0) > 2 ? 'var(--bosch-yellow-85)' : 'var(--bosch-green-50)'}"
                        [ngClass]="(sf.level || 0) > 2 ? 'rb-ic rb-ic-alert-warning-filled': 'rb-ic rb-ic-alert-info-filled'"></span>
                      {{ sf.text }}<br />
                    </ng-container>
                  </span>
                </ng-container>
              </div>

              <div *ngIf="tab.currentVehicleInsights && tab.currentVehicleInsights.evStatusCode==3"
                style="background-color: var(--bosch-yellow-95);">
                <h4 class="mb-1 ms-3">{{ tab.currentVehicleInsights.rating }}</h4>
                <ng-container *ngIf="tab.stressFactorInfo && tab.stressFactorInfo.length">
                  <span class="d-block ms-3" *ngFor="let sf of tab.stressFactorInfo">
                    <ng-container *ngIf="(sf.level || 0) > 1">
                      <span
                        [ngStyle]="{'color': (sf.level || 0) > 2 ? 'var(--bosch-yellow-85)' : 'var(--bosch-green-50)'}"
                        [ngClass]="(sf.level || 0) > 2 ? 'rb-ic rb-ic-alert-warning-filled': 'rb-ic rb-ic-alert-info-filled'"></span>
                      {{ sf.text }}<br />
                    </ng-container>
                  </span>
                </ng-container>
              </div>
              <br>
              <div class="row mt-2">
                <div class="col-md-4 d-flex justify-content-center">
                </div>
                <div class="col-md-4 d-flex justify-content-center">
                  <p><strong>State of Health</strong></p>
                </div>
                <div class="col-md-4 d-flex justify-content-center">
                  <p><strong>Range from Efficiency</strong></p>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4 centered-text">
                  <p><strong>Today</strong></p>
                </div>
                <div class="col-md-4 centered-text">
                  <p>
                    {{ tab.currentVehicleInsights?.batteryStateOfHealth ? (tab.currentVehicleInsights.batteryStateOfHealth | removeDecimalPoints:0) + '%' : 'N/A' }}
                    <span
                      class="rb-ic rb-ic-clock"
                      *ngIf="tab.currentVehicleInsights?.resultStatus === 'outdated'"
                      [rbTooltip]="'Last datapoint: ' + (tab.currentVehicleInsights?.timestamp ? (tab.currentVehicleInsights.timestamp | date:'dd MMM yyyy') : 'N/A')"
                    >
                    </span>
                    <!-- TODO: Enable result reasons tooltip -->
                    <!-- <ng-template let-close="close" let-fixed="fixed" #resultReasons>
                      <div class="p-1">
                        <button type="button" class="rb-btn rb-tiny" (click)="close()" *ngIf="fixed">
                          <span class="rb-ic rb-ic-close"></span>
                        </button>
                        <div *ngFor="let reason of tab.currentVehicleInsights?.resultReasons">
                          <span>
                            {{ reason }}
                          </span>
                          <br/>
                        </div>
                      </div>
                    </ng-template> -->
                  </p>
                </div>
                <div class="col-md-4 centered-text">
                  <p>
                    {{ getFormattedRange(tab.currentVehicleInsights?.currRange) }}
                    <span
                      class="rb-ic rb-ic-clock"
                      *ngIf="tab.currentVehicleInsights?.resultStatus === 'outdated'"
                      [rbTooltip]="'Last datapoint: ' + (tab.currentVehicleInsights?.timestamp ? (tab.currentVehicleInsights.timestamp | date:'dd MMM yyyy') : 'N/A')"
                    >
                    </span>
                    <!-- TODO: Enable result reasons tooltip -->
                    <!-- <ng-template let-close="close" let-fixed="fixed" #resultReasons>
                      <div class="p-1">
                        <button type="button" class="rb-btn rb-tiny" (click)="close()" *ngIf="fixed">
                          <span class="rb-ic rb-ic-close"></span>
                        </button>
                        <div *ngFor="let reason of tab.currentVehicleInsights?.resultReasons">
                          <span>
                            {{ reason }}
                          </span>
                          <br/>
                        </div>
                      </div>
                    </ng-template> -->
                  </p>
                </div>
              </div>
              <div class="custom-divider"></div>
              <div class="row">
                <div class="col-md-4 centered-text">
                  <p><strong>{{tab.currentVehicleInsights?.predictionDays | inTime:true }}</strong></p>
                </div>
                <div class="col-md-4 centered-text">
                  <p>
                    {{ tab.currentVehicleInsights?.predSohc ? (tab.currentVehicleInsights.predSohc | removeDecimalPoints:0) + '%' : 'N/A'}}
                    <span
                      class="rb-ic rb-ic-clock"
                      *ngIf="tab.currentVehicleInsights?.resultStatus === 'outdated'"
                      [rbTooltip]="'Last datapoint: ' + (tab.currentVehicleInsights?.timestamp ? (tab.currentVehicleInsights.timestamp | date:'dd MMM yyyy') : 'N/A')"
                    >
                    </span>
                    <!-- TODO: Enable result reasons tooltip -->
                    <!-- <ng-template let-close="close" let-fixed="fixed" #resultReasons>
                      <div class="p-1">
                        <button type="button" class="rb-btn rb-tiny" (click)="close()" *ngIf="fixed">
                          <span class="rb-ic rb-ic-close"></span>
                        </button>
                        <div *ngFor="let reason of tab.currentVehicleInsights?.resultReasons">
                          <span>
                            {{ reason }}
                          </span>
                          <br/>
                        </div>
                      </div>
                    </ng-template> -->
                  </p>
                </div>
                <div class="col-md-4 centered-text">
                  <p>
                    {{ getFormattedRange(tab.currentVehicleInsights?.predRange) }}
                    <span
                      class="rb-ic rb-ic-clock"
                      *ngIf="tab.currentVehicleInsights?.resultStatus === 'outdated'"
                      [rbTooltip]="'Last datapoint: ' + (tab.currentVehicleInsights?.timestamp ? (tab.currentVehicleInsights.timestamp | date:'dd MMM yyyy') : 'N/A')"
                    >
                    </span>
                    <!-- TODO: Enable result reasons tooltip -->
                    <!-- <ng-template let-close="close" let-fixed="fixed" #resultReasons>
                      <div class="p-1">
                        <button type="button" class="rb-btn rb-tiny" (click)="close()" *ngIf="fixed">
                          <span class="rb-ic rb-ic-close"></span>
                        </button>
                        <div *ngFor="let reason of tab.currentVehicleInsights?.resultReasons">
                          <span>
                            {{ reason }}
                          </span>
                          <br/>
                        </div>
                      </div>
                    </ng-template> -->
                  </p>
                </div>
              </div>
              <br>
              <div class="col-md-12 d-flex" *ngIf="tab">
                <div class="col-md-11 battery-certificate-container">
                  <button class="rb-btn rb-primary generate-certificate-button" [disabled]="disableCertificate || tab?.certificateStatus?.generatedCertificate >= 3 || tab?.certificateStatus?.generationStatus == true" (click)="requestCertificate(tab.batteryIdentifier)">
                    Generate Battery Certificate
                    <br>
                    (to increase trust and resale value)
                    <br>
                    Certificate requested: {{tab?.certificateStatus?.generatedCertificate || 0}} / 3
                  </button>
                </div>
                <div class="col-1 ms-0 me-0 ps-0 pe-0 d-flex justify-content-center align-items-stretch">
                  <button *ngIf="tab?.certificateStatus?.generatedCertificate > 0, else noCertificate" title="Certificate"
                    type="button" class="rb-btn rb-secondary" (click)="openDialog(demoDialog, tab.batteryIdentifier)">
                    <span class="rb-ic rb-ic-folder-download"></span>
                  </button>
                  <ng-template #noCertificate>
                    <button title="Insights" type="button" class="rb-btn rb-secondary" disabled>
                      <span class="rb-ic rb-ic-folder-download"></span>
                    </button>
                  </ng-template>
                </div>
                <ng-template #demoDialog>
                  <rb-dialog dialogTitle="Download Battery Certificate" [confirmationButtonLabel]="buttonLabels.confirmLabel"
                    [cancelButtonLabel]="buttonLabels.cancelLabel">
                    Your battery certificate is ready for download. Click 'Download' to save the file.
                  </rb-dialog>
                </ng-template>
              </div>
            </div>
            <app-ev-atomic-aging [batteryId]="tab.batteryIdentifier" [companyData]="companyData" [isMetric]="isMetric"></app-ev-atomic-aging>
          </div>
        </ng-container>
      </rb-tab-panel>
    </div>

    <hr class="ms-2 me-2 mt-1 mb-1 ps-0 pe-0">

    <div class="row ms-2 me-2 mt-1 mb-1 ps-0 pe-0">
      <div class="col-md-12 ps-0 pe-0">
        <app-ev-condition-plot [selectedVehicles]="selectedVehicles" [vehiclesInfo]="vehiclesInfo" [companyData]="companyData" [isMetric]="isMetric" [dataLoadingError]="dataLoadingError"></app-ev-condition-plot>
      </div>
      <!-- <div class="col-md-6 ps-0 pe-0">
        <app-stress-factors [selectedVehicles]="selectedVehicles" [dataLoadingError]="dataLoadingError"></app-stress-factors>
      </div> -->
    </div>
    <hr class="ms-2 me-2 mt-1 mb-1 ps-0 pe-0">
    <div class="row ms-2 me-2 mt-1 mb-1 ps-0 pe-0">
      <div class="col-md-6 ps-0 pe-0">
        <app-sohc-over-time-chart [sohTrajectories]="sohTrajectories" [errorMessageSohTrajectories]="errorMessageSohTrajectories" [dataLoadingSohTrajectories]="dataLoadingSohTrajectories" [selectedVehicles]="selectedVehicles" [dataLoadingError]="dataLoadingError"></app-sohc-over-time-chart>
      </div>
      <div class="col-md-6 ps-0 pe-0">
        <app-sohc-over-mileage-chart [sohTrajectories]="sohTrajectories" [errorMessageSohTrajectories]="errorMessageSohTrajectories" [dataLoadingSohTrajectories]="dataLoadingSohTrajectories" [selectedVehicles]="selectedVehicles" [companyData]="companyData" [isMetric]="isMetric" [dataLoadingError]="dataLoadingError"></app-sohc-over-mileage-chart>
      </div>
    </div>
    <ng-template #dynamicTab let-details="details">
      <div title="{{ details.name }}">
        {{ details.name.length > 40 ? (details.name | slice:0:40) + '...' : details.name }}
      </div>
    </ng-template>
  </ng-template>
</div>